import React, { memo, forwardRef } from "react";
const SvgAlphabetG = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M11.78 22.14c-.227-.173-.387-.347-.48-.52a1.055 1.055 0 01-.14-.5c0-.293.093-.553.28-.78.2-.213.466-.32.8-.32.12 0 .246.02.38.06.133.04.293.127.48.26.867.613 1.74.92 2.62.92.573 0 1.053-.087 1.44-.26.4-.16.713-.387.94-.68.24-.293.406-.64.5-1.04.106-.4.16-.84.16-1.32v-.7h-.04a3.439 3.439 0 01-1.34 1.08c-.534.24-1.133.36-1.8.36-.72 0-1.373-.133-1.96-.4a4.554 4.554 0 01-1.5-1.08c-.4-.453-.713-.98-.94-1.58a5.553 5.553 0 01-.34-1.94c0-.693.107-1.347.32-1.96.226-.613.54-1.147.94-1.6a4.612 4.612 0 011.48-1.08c.586-.267 1.24-.4 1.96-.4.68 0 1.313.14 1.9.42.586.28 1.053.713 1.4 1.3h.04v-.36c0-.267.04-.48.12-.64.093-.173.2-.3.32-.38a.914.914 0 01.36-.18c.133-.04.247-.06.34-.06.093 0 .2.02.32.06.133.027.26.087.38.18.12.08.22.207.3.38.093.16.14.373.14.64v7.66c0 .867-.107 1.647-.32 2.34-.213.707-.547 1.3-1 1.78-.44.493-1 .873-1.68 1.14-.68.267-1.487.4-2.42.4-.68 0-1.38-.107-2.1-.32a5.853 5.853 0 01-1.86-.88zm1.5-8.46c0 .387.06.76.18 1.12.133.36.313.687.54.98.24.28.527.507.86.68.347.173.733.26 1.16.26.44 0 .833-.08 1.18-.24.36-.173.66-.4.9-.68.253-.28.447-.6.58-.96.133-.373.2-.76.2-1.16a3.48 3.48 0 00-.2-1.18 2.893 2.893 0 00-.58-.98 2.55 2.55 0 00-.88-.66c-.347-.16-.74-.24-1.18-.24-.44 0-.833.08-1.18.24-.333.16-.62.38-.86.66a3.051 3.051 0 00-.54.96c-.12.373-.18.773-.18 1.2z"
      />
    </svg>
  );
});
SvgAlphabetG.displayName = "SvgAlphabetG";
const MemoForwardRef = memo(SvgAlphabetG);
export default MemoForwardRef;
